// extracted by mini-css-extract-plugin
module.exports = {"container":"ArcVideoPlayer_container__1ZQJO","react-player":"ArcVideoPlayer_react-player__3ULlF"};